import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import _ from 'lodash';
import Cookies from 'universal-cookie';
import { useIntl } from 'react-intl';
import CustomTypography from '../../components/Typography/CustomTypography';
import WrapperContainer from '../../components/Container/WrapperContainer';
import GridItem from '../../components/Grid/GridItem';
import Validation from '../../common/Validation';
import CleanableInput from '../../components/Input/CleanableInput';
import InputAdornment from '../../components/Input/InputAdornment';
import GridContainer from '../../components/Grid/GridContainer';
import CustomButton from '../../components/Button/CustomButton';
import { VisibilityIcon, VisibilityOffIcon } from '../../components/Icons/Icon';
import { APIErrors, Role } from '../../common/Constants';
import styles from '../../assets/jss/pages/loginAdminStyle';

const useStyles = makeStyles(styles);

export default function LoginSubAdmin(props) {
    const {
        fetchLogin, errors, isAuthorized, credential,
    } = props;
    const classes = useStyles();
    const history = useHistory();
    const intl = useIntl();
    const cookies = new Cookies();
    const [validateResults, setValidateResults] = useState({});
    const [validateRole, setValidateRole] = useState({});
    const [permission, setPermission] = useState(false);

    const [user, setuser] = useState({ email: '', password: '', showPass: 'password' });

    useEffect(() => {
        if (isAuthorized) {
            cookies.set('oesRoleAdmin', 0, { path: '/' });
            if (credential.role === Role.masterAdmin) {
                history.push(`/admin/${credential.event}/company-event-management?payment=true`);
            } else if (credential.role === Role.operatorAdmin) {
                history.push(`/admin/${credential.event}/organizer-management`);
            }
        }
    }, [isAuthorized, credential.role]);

    useEffect(() => {
        if (permission && credential.role) {
            if (credential.role !== Role.admin) {
                setValidateRole({ ...validateRole, message: { result: 'error', message: 'アクセスする権限がありません。' } });
            }
        }
    }, [permission, credential.role]);

    useEffect(() => {
        if (!_.isEmpty(errors)) {
            if (errors.code === APIErrors.badRequest) {
                setValidateRole({});
                setValidateResults({ ...validateResults, message: errors.message });
            }
        }
    }, [errors]);

    const onClickLogin = () => {
        const { email, password } = user;
        setValidateResults({});
        if (validate()) {
            fetchLogin({
                email,
                uuid: password,
                site: 'sub_admin',
            });
            setPermission(true);
        }
    };

    const validate = () => {
        const { email, password } = user;
        const validateRules = {
            email: [() => Validation.isNotEmpty(email), () => Validation.validateEmail(email)],
            password: [() => Validation.isNotEmpty(password)],
        };
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = useCallback((field, valueChange) => {
        setuser((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);
    const handleSetShowPass = useCallback(() => {
        const valueshow = user.showPass === 'password' ? 'text' : 'password';
        setuser((prevParams) => ({ ...prevParams, showPass: valueshow }));
    });

    return (
        <div className={classes.wrapper}>
            <WrapperContainer>
                <GridItem xs={12} md={12}>
                    <div className={classes.background}>
                        <GridContainer>
                            {/* <GridItem xs={12} md={3} style={{ height: '0' }} /> */}
                            <GridItem xs={12} sm={12} md={12} className={classes.mainBox}>
                                <Box className={classes.BoxContent} display="flex" justifyContent="center" flexDirection="column" height="100%">
                                    {
                                        !!validateResults.message && (
                                            <CustomTypography color="danger" variant="subtitle1">
                                                {validateResults.message.message}
                                            </CustomTypography>
                                        )
                                    }
                                    {
                                        !!validateRole.message && (
                                            <CustomTypography color="danger" variant="subtitle1">
                                                {validateRole.message.message}
                                            </CustomTypography>
                                        )
                                    }
                                    <CustomTypography className={classes.item} component="h1" variant="h3" color="info" bold>
                                        XPANDシステム
                                    </CustomTypography>
                                    <CustomTypography className={classes.itemSub} variant="h5">
                                        ※マスター・オペレーター専用
                                    </CustomTypography>
                                    <CustomTypography className={classes.item} required bold>
                                        メールアドレス
                                    </CustomTypography>
                                    <CleanableInput
                                        className={classes.item}
                                        placeholder="メールアドレスを入力してください。"
                                        defaultValue={user.email}
                                        onChange={(value) => handleSetParams('email', value)}
                                        error={!!validateResults.email}
                                        helperText={validateResults.email
                                            ? intl.formatMessage({ id: validateResults.email.message }) : ''}
                                    />
                                    <CustomTypography className={classes.item} required bold>
                                        パスワード
                                    </CustomTypography>
                                    <InputAdornment
                                        className={`${classes.item} ${classes.input}`}
                                        type={user.showPass}
                                        size="small"
                                        placeholder="アカウントパスワードを入力してください。"
                                        defaultValue={user.password}
                                        onChange={(value) => handleSetParams('password', value)}
                                        error={!!validateResults.password}
                                        helperText={validateResults.password
                                            ? intl.formatMessage({ id: validateResults.password.message }) : ''}
                                        onClick={() => handleSetShowPass()}
                                    >
                                        <>
                                            {user.showPass === 'password' && <VisibilityIcon />}
                                            {user.showPass === 'text' && <VisibilityOffIcon />}
                                        </>
                                    </InputAdornment>
                                    <Box justifyContent="center" display="flex">
                                        <CustomButton
                                            className={classes.item}
                                            size="md"
                                            round
                                            color="info"
                                            gradient
                                            onClick={onClickLogin}
                                            style={{ margin: '20px', minWidth: '140px', fontSize: '20px' }}
                                        >
                                            入場する
                                        </CustomButton>
                                    </Box>
                                </Box>
                            </GridItem>
                        </GridContainer>
                    </div>
                </GridItem>
            </WrapperContainer>
        </div>
    );
}
LoginSubAdmin.defaultProps = {
    fetchLogin: () => { },
    errors: {},
    isAuthorized: false,
    credential: {},
};

LoginSubAdmin.propTypes = {
    fetchLogin: PropTypes.func,
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    credential: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
};
